import { render, staticRenderFns } from "./AvatarV4.vue?vue&type=template&id=3cb0d465&scoped=true&"
import script from "./AvatarV4.vue?vue&type=script&lang=js&"
export * from "./AvatarV4.vue?vue&type=script&lang=js&"
import style0 from "./AvatarV4.vue?vue&type=style&index=0&id=3cb0d465&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb0d465",
  null
  
)

export default component.exports